const rankNames = {
  '4': '4', '5': '5', '6': '6', '7': '7',
  'Q': 'Dama', 'J': 'Valete', 'K': 'Rei', 'A': 'Ás', '2': '2', '3': '3',
}
const suitNames = {
  ouros: 'Ouros', espadas: 'Espadas', copas: 'Copas', paus: 'Paus',
}

export default function ViraInfo({ vira, manilhaRank }) {
  const viraText = vira
    ? `${rankNames[vira.rank] || vira.rank} de ${suitNames[vira.suit] || vira.suit}`
    : '—'
  const manilhaText = manilhaRank ? (rankNames[manilhaRank] || manilhaRank) : '—'

  return (
    <div id="vira-info" aria-label="Informações da vira">
      <p>Vira: <strong id="vira-card">{viraText}</strong></p>
      <p>Manilha: <strong id="manilha-rank">{manilhaText}</strong></p>
    </div>
  )
}
